import { TransformConvertorBase } from './transform.convertor';
import { ConditionalSplitTransformation } from 'app/model/dataflow/conditionalsplittransformation';
import { Transformation } from 'app/model/dataflow/transformation';
import { DataFlowExpression } from 'app/model/dataflow/dataflowexpression';
import { Owned } from 'app/model/base/named';
import { DataFlowExpressionUtils } from '../../expression.util';
import { BooleanDataFlowType } from 'app/model/dataflow/dataflow-datatype';
import { ConditionalSplitPlainObject } from 'worker/app-workers/shared/plainObjects/conditionalSplit.plainObject';
import { StreamPlainObject } from 'worker/app-workers/shared/plainObjects/stream.plainObject';
import { IResourceContext } from 'shell-models-lib';

export class ConditionalSplitConvertor extends TransformConvertorBase {
    private get splitTransform(): ConditionalSplitTransformation {
        return this.transformation as ConditionalSplitTransformation;
    }

    private get splitObject(): ConditionalSplitPlainObject {
        return this.transformObject as ConditionalSplitPlainObject;
    }

    public async convert(contextData: IResourceContext): Promise<Transformation> {
        await super.convert(contextData);
        this.splitTransform.disjoint = this.splitObject.disjoint;
        super.postConvert();

        return this.transformation;
    }

    public convertOutputStream(): void {
        this.splitObject.conditionExpressions.forEach((condition) => {
            this.splitTransform.addOutputStream('', false, true);
            const lastExpression = this.splitTransform.conditionExpressions[this.splitTransform.conditionExpressions.length - 1];
            lastExpression.dataFlowExpression = Owned.create<DataFlowExpression>(DataFlowExpression.MODEL, lastExpression);
            lastExpression.dataFlowExpression.expression = DataFlowExpressionUtils.unwrapExpressionWithEmptyValue(condition);
            lastExpression.dataFlowExpression.requiredReturnType = BooleanDataFlowType.TYPE;
        });

        const totalOutputStreams = this.splitObject.outputStreams.length;
        const totalExpressions = this.splitTransform.conditionExpressions.length;

        this.splitObject.outputStreams.forEach((outputStream: StreamPlainObject, index: number) => {
            if (index === totalOutputStreams - 1 && totalExpressions !== totalOutputStreams) {
                this.splitTransform.addOutputStream(outputStream.name, true, true);
            } else if (index > totalExpressions - 1) {
                this.splitTransform.addOutputStream(outputStream.name, false, true);
            } else {
                this.splitTransform.conditionExpressions[index].outputStream.name = outputStream.name;
                this.splitTransform.conditionExpressions[index].isDefault = false;
            }
        });
    }
}
